const analyticClickEvent = (label) => {
  window.gtag("event", "click", {
    'event_category': "engagement",
    'event_label': label
  })
}
export default analyticClickEvent
